export default {
	'masquerade.masqueradingAs': 'You are masquerading as %{userName}',
	'masquerade.stopMasquerading': 'Stop Masquerading'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/masquerade.js